import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { CommunicationVariables } from "../shared/communications-types";

export const COMMUNICATION_VARIABLES_QUERY_KEY = ["communications", "variables"] as const;

async function fetchVariables(communicationId: string): Promise<CommunicationVariables> {
  return httpClient<CommunicationVariables>(
    `/api/admin/communications/${communicationId}/variables`,
  );
}

/**
 * Template variable descriptor for a communication (API-COMM-4). Drives the
 * preview panel's prefilled sample data so operators don't write the JSON
 * blind. Cached aggressively — the variable contract changes only when the
 * trigger code does.
 */
export function useCommunicationVariables(communicationId: string | undefined) {
  return useQuery({
    queryKey: [...COMMUNICATION_VARIABLES_QUERY_KEY, communicationId ?? "none"] as const,
    queryFn: () => fetchVariables(communicationId as string),
    enabled: communicationId != null && communicationId.length > 0,
    staleTime: 5 * 60_000,
  });
}
